/**
 * JSR
 * e_produkt_konfigurator_2025_v2.js
 * Verze 2 JS konfigurátoru produktu (e_produkt_konfigurator_2025.js): dotazy na dostupnost a příplatky jsou sloučené do dávek (typ=12, typ=13), typ=11 a typ=13 se odesílají souběžně
 * s typ=12 (odpovědi se zpracují ve stejném pořadí jako v původní verzi) a odpovědi se krátce drží v paměti prohlížeče. Po změně barvy podnože se na pozadí dotahuje doplňkový obsah
 * z master produktu (typ=14). Načítá se všem návštěvníkům místo původní verze e_produkt_konfigurator_2025.js, která zůstává v js/ pro jistotu.
 * Po změně konfigurace ji zapisuje do GET parametru konf (base64url z "kroky|prsl|atyp"), aby šel odkaz sdílet.
 *
 * @package eshop
 *
 * @author Jiří Chalupný <jchalupny@skit.cz>
 * @copyright (c) 2007-2026 Josef Šmíd
 * @version 2.5.9
 */

$(document).ready(function() 
{
  var root = $( 'input#js_root' ).val(); 
   
  $(window).on('resize', initInfoTool);
  initInfoTool(); 
  
  /*$(window).on('load', function () {
    if (window.matchMedia('(max-width: 576px)').matches && $(window).scrollTop() === 0) {
      const $target = $('#hlavni');
      if ($target.length) {
        $('html, body').animate({
          scrollTop: $target.offset().top
        }, 1200);
      }
    }
  });*/ 
   
  let previousSluzba = null;
  
  $( ".material_change" ).change( function(e){  
    var id_kat = $( this ).val();
    $( "#kat_desky" ).val( id_kat ); 
    
    $( ".konf_blok" ).removeClass( "hidden" ); 
    var deska_konf_skryt = $( this ).attr( 'deska-konf-skryt' ).split( ',' );
    $.each( deska_konf_skryt, function(index, element) {
      $( "#konf_blok_" + element ).addClass( "hidden" );
    });
    
    if( $( this ).attr( "deska-special" ) === "1" )
    { 
      $( '.mini_konf_special input[type=radio]' ).each(function (index, element) {
        if (jQuery.inArray( id_kat , $(element).attr('data-kategorie').split(',')) !== -1 )
        { 
          $( element ).parent( 'span' ).removeClass( "hidden" ); 
        }
        else
        {
          $( element ).parent( 'span' ).addClass( "hidden" );
        }
      });  
    }
    
    if( previousSluzba !== null )
    {    
      $( "#konf_prvek_" + previousSluzba.attr( "extra_sluzba" ) ).prop('checked', false);
      $( "#konf_prvek_" + previousSluzba.data("zakaz_tloustka") ).parent().removeClass( "hidden" );
      const dekory = String( previousSluzba.data("zakaz_dekor") || "" ).split(",").filter(Boolean);//materiál se službou nemusí mít zakázané dekory
      dekory.forEach(function (dekor, index) {
        $("#konf_prvek_" + dekor + ", #konf_prvek_zmen_" + dekor).prop("disabled", false).parent().removeClass("zakaz_dekor_disabled");
      });
      
      previousSluzba = null;
    }
     
    if( $( this ).attr( "extra_sluzba" ) )
    {
      const tloustka = $(this).data("zakaz_tloustka");  
      const dekory = String( $(this).data("zakaz_dekor") || "" ).split(",").filter(Boolean);//materiál se službou nemusí mít zakázané dekory
      $( "#konf_prvek_" + $( this ).attr( "extra_sluzba" ) ).prop('checked', true);
      previousSluzba = $( this );
      
      // 1. Zkontrolovat, jestli radio s ID rovno `tloustka` není vybrán
      const $radioTloustka = $("#konf_prvek_" + tloustka);  
      if ($radioTloustka.prop("checked")) {  
        // Vybrat následující radio za tímto
        const $next = $radioTloustka.closest("label, span, div").next().find("input[type='radio']").first();
        if ($next.length) {
          $next.prop("checked", true);
        }
      }
      
      $("#konf_prvek_" + tloustka).parent().addClass( "hidden" );
      
      // 2. Zkontrolovat, jestli některý radio box s hodnotou z dekory je vybrán
      const anyChecked = dekory.some(function (val) {
        return $("#konf_prvek_" + val).is(":checked");
      });

      if (anyChecked) {
        // Vybrat první nedisabled radio s odpovídající hodnotou
        $('input[name="vyber_10014"]').first().prop("checked", true);
      }
      
      dekory.forEach(function(dekor, index) {
        $("#konf_prvek_" + dekor + ", #konf_prvek_zmen_" + dekor).prop( "disabled", true ).prop( "checked", false ).parent().addClass( "zakaz_dekor_disabled" );
      });
    }
     
    //musím se zachovat, jako by se právě otevřel konfigurátor - načíst dostupnosti, apod.
    if( $( "#konf_vyber_1" ).length > 0 )
    {
      var bez_dost_ceny = true;
      pripravSkrytKrok( $( ".mini_konf_select:first" ).attr( "data-krok-prefix" ), $( ".mini_konf_select:first" ).attr( "data-krok-prefix" )+"|k2|", $( ".mini_konf_select:first" ).attr( "data-can_objednat" ), $( "#kat_konf" ).val() ); 
      $( "#konf_vyber_1" ).trigger("change");
      dokonciSkrytKrok();//pokud handler změny sloučený krok nespotřeboval, provede se původní samostatný dotaz
      bez_dost_ceny = false; 
      $(window).scroll();
    } 
    
    if( $( this ).attr( "deska-special" ) === "1" )
    {
      poDokonceni( function() {//výběr první nedisabled volby potřebuje hotové dostupnosti
        $( '.mini_konf_special input[type=radio]').attr('checked', false);
        $( '.mini_konf_special input[type=radio]:not(.hidden):not(:disabled)' ).first().attr('checked', true).trigger('change');
      });
    } 
  });
  
  //malý konfigurátor
  var prvni_pruchod = 0;
  $( ".mini_konf_select" ).change( async function(e){  
    if( $( this ).attr( "data-poradi" ) === "3" && $( this ).attr(  "data-typ" ) === "1" && $( "#" + $( this ).attr( "id" ) + " input[type='radio']:checked" ).val() === "atyp" && $( "label[for='konf_prvek_atyp'] .extra_pole" ).attr( "data-val" ) === "" ) { e.preventDefault(); e.stopPropagation(); return; }
    var beh = 0;//číslo běhu, zahazování zastaralých odpovědí
    var byl_prvni_pruchod = ( prvni_pruchod === 0 );//podnož-master se má volat jen při skutečné změně, ne při prvotním načtení
    try
    {
    var def = "";
    var def_kosik = "";
    var val = "";
    var krok = "0";
    var bez_desky = false;
    var poradi = $( this ).attr( "data-poradi" ); 
    var vl = $( "label[for='konf_prvek_atyp'] .extra_pole" ).attr( "data-val" );
    var akt_predpocet = $( this ).attr( "data-akt-predpocet" );
    var predpocet_data = [];
    var kroky_dostupnost_batch = [];//nasbírané kroky pro sloučené volání typ=12 místo N volání typ=1
    var odlozene_zakazy = [];//zákazy voleb dalšího kroku se provedou až spolu s odpovědí typ=12, ať prvky neblikají zašedle
    var vymazPopisky = function() { $.each( predpocet_data, function( k, p ) { $( ".mini_konf_select[data-vyber='" + p.vyber + "'] .extra_pole_cena" ).html( "" ); } ); };//popisky příplatků se maží až těsně před doplněním nových
    var typ11_volani_fronta = [];//odložená volání nactiCenuDostupnostImg (typ=11, může nastat i vícekrát u bez_desky), ať proběhnou až po typ=12, stejně jako v originále
    var def_kroky = null;//def jen s kroky k1, k2 (k3) bez volitelného příslušenství, pro GET parametr konf

    if( prvni_pruchod === 0 ) akt_predpocet = "1";
    
    if( $( "#konf_vyber_3 input[type='radio']:checked" ).val() === "bez_desky" ) bez_desky = true;//musím zde mít prvek napevno, abych se na něj vždy podíval, jestli nemám výběr bez desky
    else 
    {
      $( ".konf_bez_desky" ).removeClass( "konf_bez_desky" );
      $( ".zobrazit_bez_desky" ).attr( "data", "101,102,105" );
    } 
     
      $( ".mini_konf_select" ).each(function ( index )
      {  
        if( vynechatVyber( $(this).attr("data-vyber") ) ) return true;
        if( bez_desky && $( this ).attr( "data-krok" ) !== "0" ) return false;
        if( def_kroky === null && $( this ).attr( "data-typ" ) === "2" ) def_kroky = def;//první příslušenství, kroky podnože a desky jsou hotové
        if( krok !== $( this ).attr( "data-krok" )  )
        {
          if (def.slice(-1) !== ":")
          {
            def += ":";
            def_kosik += ":";
          }
          krok = $( this ).attr( "data-krok" );
        }
        var prefix = $( this ).attr( "data-krok-prefix" );
        if( prefix !== false && typeof prefix !== 'undefined' && $( this ).attr(  "data-typ" ) !== "3" )
        {
          def += prefix;
          def_kosik += prefix;
        } 

        var konf_blok = "#" + $( this ).attr( "id" ); 
        if( parseInt( $( this ).attr( "data-poradi" ) ) < 5 ) konf_blok = "#konf_blok_" + $( this ).attr( "data-vyber" ) + " " + konf_blok;
        
        if( $( this ).attr(  "data-typ" ) === "1" ) 
        { 
          val = $( konf_blok + " input[type='radio']:checked" ).length ? $( konf_blok + " input[type='radio']:checked" ).val() : '';
          if( val !== '' )
          {
            def += "_" + val; 
            def_kosik += "_" + val; 
          }  
        }
        else if( $( this ).attr(  "data-typ" ) === "3" ) 
        { 
          val = $( konf_blok + " input[type='radio']:checked" ).length ? $( konf_blok + " input[type='radio']:checked" ).val() : '';
          def += "" + val; 
          def_kosik += "" + val; 
        }
        else if( $( this ).attr(  "data-typ" ) === "2" )
        {  
          if( $( konf_blok + " input[type='checkbox']").is(':checked') )
          { 
            if( $( this ).attr(  "data-prohodit" ) === "1" )
            { 
              if( $( konf_blok + " select" ).length > 0 )
              {
                if( $( konf_blok + " select" ).val() === "" )
                {
                  $( konf_blok + " input[type='checkbox']" ).attr( "disabled", true ); 
                  $( konf_blok + " select" ).focus().css( "background-color", "rgba(255, 0, 0, 0.8)" );
                  $( ".koupit_stul" ).attr( "disabled", true ); 
                  return false;
                }
                else
                {
                  def_kosik += $( konf_blok + " select" ).val();
                  $( konf_blok + " select" ).css("background-color", ""); 
                  $( ".koupit_stul" ).attr( "disabled", false );
                  $( konf_blok + " input[type='checkbox']" ).attr( "disabled", false ); 
                }
                def += $(konf_blok + " input[type='checkbox']:checked").val();
                def_kosik += "-" + $(konf_blok + " input[type='checkbox']:checked").val() + ";true2";
              }
            }
            else
            {
              def += $( konf_blok + " input[type='checkbox']:checked" ).val();
              def_kosik += $( konf_blok + " input[type='checkbox']:checked" ).val();
              if( $( konf_blok + " select" ).length > 0 )
              {
                if( $( konf_blok + " select" ).val() === "" )
                {
                  $( konf_blok + " input[type='checkbox']" ).attr( "disabled", true ); 
                  $( konf_blok + " select" ).focus().css( "background-color", "rgba(255, 0, 0, 0.8)" );
                  $( ".koupit_stul" ).attr( "disabled", true ); 
                  return false;
                }
                else
                {
                  def_kosik += "-" + $( konf_blok + " select" ).val() + ";true";
                  $( konf_blok + " select" ).css("background-color", ""); 
                  $( ".koupit_stul" ).attr( "disabled", false );
                  $( konf_blok + " input[type='checkbox']" ).attr( "disabled", false ); 
                }
              }
            }
          } 
          else 
          { 
            def = def.slice(0,-1);
            def_kosik = def_kosik.slice(0,-1);
          }
        }
        else 
        {   
          val = $(this).val() || '';
          if( val !== '' )
          {
            def += "_" + val; 
            def_kosik += "_" + val;  
          }
        }
          
        if( index === $( ".mini_konf_select" ).length - 1 || bez_desky )//$( ".mini_konf_select" ).length === parseInt( $( this ).attr( "data-poradi" ) ) nefunguje, nyní mám všechny výběry kvůli přepínání materiálu, chci volat při posledním průchodu
        {
          if( bez_dost_ceny !== true )
          {
            typ11_volani_fronta.push( [ def_kosik, $( "#kat_konf" ).val(), window.slider_bx, ( def.indexOf( "atyp" ) > 0 ? vl : "" ), prvni_pruchod ] );//jen nasbírat, zavolat až po typ=12
          }
        }
        else if( poradi <= $( this ).attr( "data-poradi" ) )
        {
          //nastavit viditelnost položek, v případě nevhodné kombinace označit následující selecty červeně, vypsat chybovou hlášku, ukončit cyklus
          var dalsi_krok = nactiDalsiKrokKonf( parseInt( $( this ).attr( "data-poradi" ) ), odlozene_zakazy );
          kroky_dostupnost_batch.push({ kod_produktu: dalsi_krok, vsechny_kody: def, can_objednat: $( this ).attr( "data-can_objednat" ), kat_desky: $( "#kat_desky" ).val(), vl: ( def.indexOf( "atyp" ) > 0 ? vl : "" ) });//místo okamžitého volání nactiKonfDostupnost() jen nasbírat
        }
        
        if( akt_predpocet === "1" )
        {
          if( $( this ).attr( "data-predpocet" ) === "1" ) 
          { 
            ///nactiKonfPredpocet( dalsi_krok, val, $( "#kat_konf" ).val(), $( "#kat_desky" ).val(), $( this ).attr( "data-vyber" ), $( this ).attr( "data-krok" ) );
            predpocet_data.push({ aktualni_kod: val, kategorie: $( "#kat_konf" ).val(), kat_desky: $( "#kat_desky" ).val(), vyber: $( this ).attr( "data-vyber" ), krok: $( this ).attr( "data-krok" ) });
          }
        }
      });
    beh = ++aktualniBeh;
    behStart();
    //typ=11 a typ=13 potřebují jen def_kosik, takže se odešlou hned souběžně s typ=12; zpracují se až po typ=12 a kontrole chyb ve stejném pořadí jako dřív
    var pozadavky11 = typ11_volani_fronta.map( function( args ) { return odesliCenuDostupnostImg( args[0], args[1], args[3] ); } );
    var pozadavek13 = odesliKonfPredpocetBatch( def_kosik.replaceAll( ":", "|" ), predpocet_data );
    var odskrtnuto = await nactiKonfDostupnostBatch( kroky_dostupnost_batch, $( "#kat_konf" ).val(), beh, odlozene_zakazy );
    if( beh !== aktualniBeh ) return;//mezitím začala novější změna, tenhle běh končí
    if( odskrtnuto && pocetOpakovani < 5 )//odpověď odškrtla volbu, kterou už smyčka zahrnula do def (v originále přišla odpověď dřív než čtení checkboxů) → spočítat znovu
    {
      pocetOpakovani++;
      $( this ).trigger( "change" );
      return;
    }
    //jedno sloučené volání místo N volání nactiKonfDostupnost() z předchozí smyčky
    for( var i11 = 0; i11 < pozadavky11.length; i11++ ) await zpracujCenuDostupnostImgPozadavek( pozadavky11[i11], typ11_volani_fronta[i11][2], typ11_volani_fronta[i11][4], beh );//odpovědi se zpracují až teď, po typ=12, stejné pořadí jako v originále
    if( beh !== aktualniBeh ) return;//mezitím začala novější změna, tenhle běh končí
    //zde projít všechny selecty, jestli některý nemá vybrán option který je disabled - pokud najdu vypsat chybu a označit daný select
    var chyba = 0;
    $( ".mini_konf_select" ).each(function ()
    { 
      if( vynechatVyber( $(this).attr("data-vyber") ) ) return true;
      if( $( this ).find( ":selected:disabled" ).length > 0 && !bez_desky )
      {
        $( "#mini_konfigurator_chyba" ).removeClass( "hidden" );
        $( ".koupit_stul" ).attr( "disabled", true );
        $( this ).parent().css( "background-color", "rgba(255, 0, 0, 0.1)" );
        chyba = 1;
      }
      else if( ( $( this ).find( ":checked:disabled" ).length > 0 || ( $( this ).find( "input[type=radio]" ).length > 0 && !$( this ).find( "input[type=radio]:checked" ).length ) ) && !bez_desky )
      { 
        $( "#mini_konfigurator_chyba" ).removeClass( "hidden" );
        $( ".koupit_stul" ).attr( "disabled", true );
        if( $( this ).attr(  "data-typ" ) !== "2" )
          $( this ).parent().css( "background-color", "rgba(255, 0, 0, 0.1)" );
        chyba = 1;
      }
      else
      {
        $( this ).parent().css("background-color", ""); 
        if( bez_desky && ( $( this ).attr( "data-krok" ) !== "0" ) )
        {
          $( this ).not( "#konf_vyber_3" ).parent().addClass( "konf_bez_desky" );
          $( ".zobrazit_bez_desky" ).attr( "data", "101,104" );
          $( ".sluzby, .material" ).addClass( "konf_bez_desky" );
          $( ".extra_pole_cena" ).html( "" ); 
        }
      } 
    });
    //u nedostupných dekorů chci vypsat info navíc
    //$( "#zmenit_vyber_dekor label" ).attr( "title", "" );
    $( "#zmenit_vyber_dekor label i" ).hide();
    //$( "#zmenit_vyber_dekor .hidden_sedy label" ).attr( "title", $( "#zmenit_vyber_dekor" ).attr( "data-hidden" ) );
    $( "#zmenit_vyber_dekor .hidden_sedy:not(.zakaz_dekor_disabled) label i.dekor_info_rozmer" ).show();
    $( "#zmenit_vyber_dekor .zakaz_dekor_disabled label i.dekor_info_oblina" ).show();

    $('#konf_vyber_4 input[type="radio"]').each(function () {
      const $img = $('label[for="' + this.id + '"] img');

      if (this.disabled) {
        //dekor zakázaný kvůli vybranému materiálu (bez obliny) vs. klasicky nedostupný dekor
        const txt = $(this).parent().hasClass( "zakaz_dekor_disabled" )
          ? $("#zmenit_vyber_dekor").data("disabledOblina")
          : $("#zmenit_vyber_dekor").data("disabled");
        $img.attr('title', $img.attr('alt') + '<br><i>' + txt + '</i>');
      } else {
        $img.attr('title', $img.attr('alt'));
      }
    });
    
    initMobileSelect();//potřebuji znovu načíst upravené selecty pro menší rozlišení
    
    if( chyba === 0 )
    {
      $( "#mini_konfigurator_chyba" ).addClass( "hidden" );
      $( "#mini_konf_produkty" ).val( def_kosik.replaceAll( ":", "|" ) );
      if( !byl_prvni_pruchod ) ulozKonfDoUrl( def_kroky !== null ? def_kroky : def, bez_desky ? [] : vybranePrislusenstvi(), ( def.indexOf( "atyp" ) > 0 ? vl : "" ) );//konfigurace do GET parametru konf, zatím jen zápis
      $( ".koupit_stul" )./*attr( "onclick", "window.location='" + $( ".koupit_stul" ).attr( "url-def" ).replace( "replace", def ) + ( bez_dost_ceny !== true ? "?min=1" : "?min=0" ) + "'" ).*/attr( "disabled", false );
      //$( ".koupit_konfigurator" ).attr( "href", $( ".koupit_konfigurator" ).attr( "url-def" ).replace( "replace", def ) + ( bez_dost_ceny !== true ? "?min=1" : "?min=0" ) ).attr( "disabled", false );
      var predpocet_ok = await zpracujKonfPredpocetPozadavek( pozadavek13, beh );//jedno sloučené volání typ=13 místo N volání typ=7; požadavek byl odeslán souběžně s typ=12
      if( beh === aktualniBeh && !predpocet_ok ) vymazPopisky();//odpověď se nepoužila (např. chyba sítě), popisky zůstanou prázdné jako dřív
    } 
    else vymazPopisky();//nekonfigurovatelný stůl, popisky příplatků zůstanou prázdné jako dřív
    $( ".koupit_stul" ).removeClass( "loading" );
    prvni_pruchod = 1;
    if( !byl_prvni_pruchod && $( this ).attr( "id" ) === "konf_vyber_1" )
    {
      //barva podnože se změnila; doplňkový obsah (popis, fotogalerie, příslušenství) se dotáhne až teď, na pozadí, ať nezdržuje běh ani loading na tlačítku
      nactiPodnozMasterAktualni();
    }
    }
    finally
    {
      if( beh !== 0 && beh === aktualniBeh ) behStop();//i při výjimce nebo předčasném konci se běh ukončí a loading na tlačítku nezůstane viset
    }
  });
   
  //změna povrchu
  $('#zmenit_vyber').click(function ()
  { 
    //$('body').css('overflow', 'hidden');
    //$(window).scrollTop( 0 );
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();  
    var slider_bx_povrch = null;
    $("#zmenit_vyber_dekor").dialog({
      resizable: true,
      width: ( windowWidth <= 600 ? windowWidth - 50 : ( windowWidth >= 1200 ? "1150" : "90%" ) ),
      height: ( windowHeight <= 920 ? windowHeight - 80 : "920" ),
      modal: true,
      closeText: "",
      dialogClass: "dialog_konfigurator",
      open: function() { 
          initMobileSelect( 1 );
        
          $( "#zmenit_vyber_submit, #zmenit_vyber_submit_2" ).click(function(){ 
            $("#zmenit_vyber_dekor").dialog("close");
          }); 
 
          if( $( "#zmenit_vyber_dekor input[type='radio']:checked" ).val() )
          {
            slider_bx_povrch = $( '#eshop_obrazek_slider_span_' + $( "#zmenit_vyber_dekor input[type='radio']:checked" ).val() ).bxSlider({
              mode: 'fade',
              speed: 0,
              infiniteLoop: true, 
              controls: true,
              touchEnabled: false,//swipe nefunguje na iOs a ve chrome blbne - nefungují eventy
              keyboardEnabled: true 
              /*onSlideBefore: function($slideElement, oldIndex, newIndex){
          var $lazy = $slideElement.find(".lazy")
          var $load = $lazy.attr("data-src");
          $('.lazy img').load(function(){
              $lazy.attr("src",$load).removeClass("lazy");
          });
      },*/
            }); 
          }
        
        $( ".prvky_dekoru input[type='radio']" ).change( function(){  
          if( slider_bx_povrch ) slider_bx_povrch.destroySlider();
          $( ".popisy_dekoru span, .fotky_dekoru div.konf_prvek_zmen_fotky" ).addClass( "hidden" );
          $( "#konf_prvek_zmen_popis_" + $( this ).val() ).removeClass( "hidden" );
          $( "#konf_prvek_zmen_fotky_" + $( this ).val() ).removeClass( "hidden" );
          slider_bx_povrch = $( '#eshop_obrazek_slider_span_' + $( this ).val() ).bxSlider({
            mode: 'fade',
            speed: 0,
            infiniteLoop: true, 
            controls: true,
            touchEnabled: false,//swipe nefunguje na iOs a ve chrome blbne - nefungují eventy
            keyboardEnabled: true 
          }); 
        });
        
        $( "#konf_prvek_zmen_" + $( "#konf_vyber_4 input[name=vyber_10014]:checked" ).val() ).prop('checked', true).change();
        openDialogScroll();
      }, 
      close: function() {
        closeDialogScroll();
      },
      beforeClose: function () {
        //$('body').css('overflow', '');
        if( slider_bx_povrch ) slider_bx_povrch.destroySlider();
      },
      buttons: {
        "Zavřít": function () {
          //$('body').css('overflow', '');
          if( slider_bx_povrch ) slider_bx_povrch.destroySlider();
          $(this).dialog("close");
        }
      }
    });
    return false;
  });
  //přendáno mimo dialog open, abych mohl volat i z jiného místa
  $( "#zmenit_vyber_submit, #zmenit_vyber_submit_2" ).click(function(){  
    var vybran = $( "#zmenit_vyber_dekor input[type='radio']:checked" );  
    $( "#konf_prvek_" + vybran.attr( "value" ) ).click(); 
  });
  
  //velikost atypu   
  $('#konf_prvek_atyp').click(function ()
  { 
    var windowWidth = $(window).width();
    $("#zmena_velikosti").dialog({
      resizable: true,
      width: ( windowWidth <= 700 ? windowWidth - 50 : "700px" ),
      modal: true,
      closeText: "",
      dialogClass: "dialog_konfigurator",
      open: function() {
        /*$( "#zmena_velikosti #width" ).click();
        $("#zmena_velikosti input[type='number']").click(function ()
        {
          $(this).addClass('zmena_velikosti_input');
          $(this).parent('div').children('.zmena_velikosti_range').slideDown("slow", function () {});
          $(this).parent('div').children('.zmena_velikosti_range').show();
        });*/
        $( "#zmenit_atyp" ).click(function(){ 
          $("#zmena_velikosti").dialog("close");
        });
        $( "#zmena_velikosti #width, #zmena_velikosti #height" ).change(function() {
          if( parseInt( $( this ).attr( "min" ) ) > parseInt( $( this ).val() ) || $( this ).val() === "" ) $( this ).val( $( this ).attr( "min" ) );
          if( parseInt( $( this ).attr( "max" ) ) < parseInt( $( this ).val() ) || $( this ).val() === "" ) $( this ).val( $( this ).attr( "max" ) );
          $( this ).val( ziskejCeleCislo( $( this ).val() ) );
        });
        openDialogScroll();
      }, 
      close: function() {
        //var width = $("#zmena_velikosti #width").val().replace(/\D/g, '');
        //var height = $("#zmena_velikosti #height").val().replace(/\D/g, '');
        var width = ziskejCeleCislo($("#zmena_velikosti #width").val());
        var height = ziskejCeleCislo($("#zmena_velikosti #height").val());

        $("label[for='konf_prvek_atyp'] .nazev").contents().filter(function () {
          return this.nodeType === 3; // textový uzel
        }).first().replaceWith($("label[for='konf_prvek_atyp'] .extra_pole").attr("data-text") + " (" + width + "x" + height + ")");
        $("label[for='konf_prvek_atyp'] .extra_pole").html($("label[for='konf_prvek_atyp'] .extra_pole").attr("data-zmenit"));
        $("label[for='konf_prvek_atyp'] .extra_pole").attr("data-val", width + "x" + height);
        $("#mini_konf_rozmer").val(width + "x" + height + " cm");

        $("label[for='konf_prvek_atyp']").change();
        closeDialogScroll();
      },
      beforeClose: function () {
        //$('body').css('overflow', ''); 
        //nastavování a kontrola hodnot přesunuta do close - zde nereagovalo na zavření pomocí ESC
      },
      buttons: {
        "Zavřít": function () {
          //$('body').css('overflow', '');
          
          $(this).dialog("close");
        }
      }
    });
  });
  
  //prvotní načtení po otevření stránky
  var zobrazKonfigurator = function() { $( "#mini_konfigurator" ).css( "visibility", "" ); };//produkt bez desky - konfigurátor je skrytý do přepnutí na bez desky (viz šablona)
  var $material_sluzba = $( ".material_change:checked" ).filter( function() { return !!$( this ).attr( "extra_sluzba" ); } );//materiál se službou (např. oblina) ze sdíleného odkazu, viz konf_url v e_produkt.php
  if( $material_sluzba.length > 0 && $( "#konf_vyber_1" ).length > 0 )
  {
    $material_sluzba.trigger( "change" );//stejně jako ruční výběr materiálu - zaškrtne službu, nastaví zákazy tloušťky a dekorů a provede prvotní načtení
    poDokonceni( zobrazKonfigurator );
  }
  else if( $( "#konf_vyber_1" ).length > 0 )
  {
    var bez_dost_ceny = true;
    if( ( $( "#tri_d" ).val() === "1" || $( "#tri_d" ).val() === "2" ) && $( "#konf_prvek_bez_desky[data-vychozi='1']" ).length === 0 ) bez_dost_ceny = false;//v tři D konfigurátoru chci načítat rovnou obrázek; u produktu bez desky až po přepnutí na bez desky, ať neproblikne stůl s deskou
    pripravSkrytKrok( $( ".mini_konf_select:first" ).attr( "data-krok-prefix" ), $( ".mini_konf_select:first" ).attr( "data-krok-prefix" )+"|k2|", $( ".mini_konf_select:first" ).attr( "data-can_objednat" ), $( "#kat_konf" ).val() ); 
    $( "#konf_vyber_1" ).trigger("change");
    dokonciSkrytKrok();//pokud handler změny sloučený krok nespotřeboval, provede se původní samostatný dotaz
    bez_dost_ceny = false;
    //produkt bez desky (viz e_produkt.php) - konfigurátor se nejdřív načte s deskou, aby se skryly volby nedostupné pro podnož i desku, a teprve pak se přepne na bez desky jako při kliknutí
    if( $( "#konf_prvek_bez_desky[data-vychozi='1']" ).length > 0 )
      poDokonceni( function() { $( "#konf_prvek_bez_desky" ).prop( "checked", true ).trigger( "change" ); poDokonceni( zobrazKonfigurator ); } );
    else zobrazKonfigurator();
    $(window).scroll();
  }

  //konfigurace ze sdíleného odkazu s jinou barvou podnože než výchozí: doplňkový obsah k podnoži (typ=14) se dotáhne stejně jako po ruční změně barvy, až po dokončení prvotního načtení, ať ho nezdržuje
  if( $( "#mini_konfigurator" ).attr( "data-konf-url-podnoz" ) === "1" ) poDokonceni( nactiPodnozMasterAktualni );

  $( ".konf_blok .nadpis_h3 span" ).click( function(){
    $( "#" + $( this ).attr( "data" ) ).click(); 
  });
    
  $( "#open_prodejny_desky_vybrat" ).click(function(){ 
    if( $( "#open_prodejny_form input[name=deska_prodejna]" ).is(':checked') )
    {
      var deska = $( "#open_prodejny_form input[name=deska_prodejna]:checked" ).val().split("_"); 
      var klik = function( i )//další kliknutí až po dokončení dostupností z předchozího
      {
        if( i > 3 ) return;
        $( "#konf_prvek_" + deska[i] ).click();
        poDokonceni( function() { klik( i + 1 ); } );
      };
      klik( 1 );
      //$( "#zmenit_vyber_submit" ).click();
    }
    $("#open_prodejny_form").dialog("close");
  });
  
  /*var slider_bx_sluzby = null;
  $( '.sluzba_zjisti_vice' ).click(function()
  {
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    $( 'div#sluzba_popis_' + $( this ).attr( "data-id" ) ).dialog({
      width: ( windowWidth <= 600 ? windowWidth - 50 : "60%" ),  
      height: ( windowWidth <= 600 ? windowHeight*0.9 : windowHeight*0.7 ),
      modal: true,
      resizable: true,
      dialogClass: "dialog_web", 
      beforeClose: function () {
        if (slider_bx_sluzby)
            slider_bx_sluzby.destroySlider();
      },
      buttons: {
        Close: function() { 
          $( this ).dialog( "close" );
        }
      }
    });

    if( $('#eshop_obrazek_slider_sluzba_' + $( this ).attr( "data-id" )).length > 0 )
    {
      slider_bx_sluzby = $('#eshop_obrazek_slider_sluzba_' + $( this ).attr( "data-id" )).bxSlider({
        mode: 'fade',
        speed: 0,
        infiniteLoop: true,
        controls: true,
        touchEnabled: false
      });
      slider_bx_sluzby.reloadSlider();
    }
    return false;
  });*/
  
  $( '#materialy_popis' ).click(function()
  {
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    $( 'div#materialy_popis_dialog' ).dialog({
      width: ( windowWidth <= 550 ? windowWidth - 50 : "550px" ),  
      height: ( windowWidth <= 600 ? windowHeight*0.9 : windowHeight*0.8 ),
      modal: true,
      resizable: true,
      dialogClass: "dialog_konfigurator", 
      open: function() {
        openDialogScroll();
      },
      close: function() {
        closeDialogScroll();
      },
      beforeClose: function () {
   
      },
      buttons: {
        Close: function() { 
          $( this ).dialog( "close" );
        }
      }
    });  
    
    return false;
  });
  
  $( '#podnoze_popis' ).click(function()
  {
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    $( 'div#podnoze_popis_dialog' ).dialog({
      width: ( windowWidth <= 550 ? windowWidth - 50 : "550px" ),  
      height: ( windowWidth <= 600 ? windowHeight*0.9 : windowHeight*0.8 ),
      modal: true,
      resizable: true,
      dialogClass: "dialog_konfigurator", 
      open: function() {
        openDialogScroll();
      },
      close: function() {
        closeDialogScroll();
      },
      beforeClose: function () {
   
      },
      buttons: {
        Close: function() { 
          $( this ).dialog( "close" );
        }
      }
    });  
    
    return false;
  });
   
  //initMobileSelect(); přidám na konec procházení konfigurátoru
  $(window).on('resize', initMobileSelect);
    
  
});

function ziskejCeleCislo(hodnota) {
    var m = hodnota.match(/\d+/);
    return m ? m[0] : '';
}

function initMobileSelect( extra=0 ) {
  let typ = ".radio_hodnoty_img";//.radio_hodnoty, 
  let typClass = "mobile-dropdown-wrapper-hodnoty";
  
  if( extra === 1 )
  {
    typ = ".prvky_dekoru";
    typClass = "mobile-dropdown-wrapper-dekor";
  }
  // zničíme staré wrappery
  $('.' + typClass).remove();
  $(typ).show().each(function () {
    $(this).removeData('mobile-select-init');
  });

  if (window.matchMedia('(max-width: 991px)').matches) {
    $(typ).each(function () {
      const $container = $(this);
      if ($container.data('mobile-select-init')) return;

      const isImageType = $container.hasClass('radio_hodnoty_img');
      const $wrapper = $('<div class="mobile-dropdown-wrapper ' + typClass + '"></div>');
      const $selected = $('<div class="mobile-selected"></div>');
      const $optionsWrapper = $('<div class="mobile-options"></div>');

      $container.find('span').each(function () {
        const $span = $(this);
        
        if ($span.hasClass('hidden')) return; // přeskočíme skryté volby
        
        const $radio = $span.find('input[type="radio"]');
        const $optionDiv = $('<div class="mobile-option"></div>');
        const $label = $span.find('label');

        // --- Rozdíl mezi textovým a obrázkovým typem ---
        if (isImageType) {
          const $img = $label.find('img');
          const title = $img.attr('title') || $radio.data('nazev') || $radio.val();
          const src = $img.attr('src');
          $optionDiv.html(`<img src="${src}" alt="${title}" title="${title}"><span>${title}</span>`);
        } else {
          $optionDiv.html($label.html());
        }
        
        if ($optionDiv.find('img').length) {
          $wrapper.addClass('has-image');
        }

        // --- Disabled / readonly ---
        if ($radio.is(':disabled') || $radio.is('[readonly]')) {
          $optionDiv.addClass('disabled');
          return $optionsWrapper.append($optionDiv);
        }

        // --- Aktuálně vybraný ---
        if ($radio.is(':checked')) {
          let $content;
          if (isImageType) {
            const $img = $label.find('img');
            const title = $img.attr('title') || $radio.data('nazev') || $radio.val();
            const src = $img.attr('src');
            $content = `<img src="${src}" alt="${title}" title="${title}"><span>${title}</span>`;
          } else {
            const $labelClone = $label.clone();
            $labelClone.find('.extra_pole').remove();
            $content = $labelClone.html();
          }
          $selected.html($content);
          $optionDiv.addClass('selected');
        }

        // --- Kliknutí na volbu ---
        $optionDiv.on('click', function (e) {
          e.stopPropagation();
          if ($optionDiv.hasClass('disabled')) return;

          $radio.prop('checked', true).trigger('change').trigger('click');
          $optionsWrapper.find('.mobile-option').removeClass('selected');
          $optionDiv.addClass('selected');

          let $content;
          if (isImageType) {
            const $img = $label.find('img');
            const title = $img.attr('title') || $radio.data('nazev') || $radio.val();
            const src = $img.attr('src');
            $content = `<img src="${src}" alt="${title}" title="${title}"><span>${title}</span>`;
          } else {
            const $labelCloneClick = $label.clone();
            $labelCloneClick.find('.extra_pole').remove();
            $content = $labelCloneClick.html();
          }
          $selected.html($content);

          $optionsWrapper.slideUp(150);
          $selected.removeClass('open_select');
        });

        $optionsWrapper.append($optionDiv);
      });

      // --- Otevření / zavření dropdownu ---
      $selected.on('click', function (e) {
        e.stopPropagation();
        $('.mobile-options').not($optionsWrapper).slideUp(150);
        $('.mobile-selected').not($selected).removeClass('open_select');
        $optionsWrapper.slideToggle(150);
        $selected.toggleClass('open_select');
      });
      
      // Sleduj scrollování okna
      $(window).on('scroll', function () {
        $('.mobile-dropdown-wrapper .mobile-options:visible').each(function () {
          const $options = $(this);
          const $wrapper = $options.closest('.mobile-dropdown-wrapper');
          const wrapperTop = $wrapper.offset().top;
          const wrapperBottom = wrapperTop + $wrapper.outerHeight();
          const windowTop = $(window).scrollTop();
          const windowBottom = windowTop + $(window).height();

          // Pokud wrapper není v zobrazené části okna, zavři select
          if (wrapperBottom < windowTop || wrapperTop > windowBottom -250) {
            $options.slideUp(150);
            $wrapper.find('.mobile-selected').removeClass('open_select');
          }
        });
      });

      $wrapper.append($selected).append($optionsWrapper);
      $container.hide().after($wrapper);
      $container.data('mobile-select-init', true);
    });

    // zavřít klikem mimo
    $(document).off('click.mobileSelect').on('click.mobileSelect', function (e) {
      if (!$(e.target).closest('.mobile-dropdown-wrapper').length) {
        $('.mobile-options').slideUp(150);
        $('.mobile-selected').removeClass('open_select');
      }
    });

  } else {
    // zpět na desktop
    $('.mobile-dropdown-wrapper').remove();
    $(typ).show().each(function () {
      $(this).removeData('mobile-select-init');
    });
  }
}



//výběry které nejsou relevatní pro daný materiál chci přeskočit aby se nezpracovávaly
function vynechatVyber( vyber_id )
{
  if ( $('input.material_change:checked').attr('deska-konf-skryt') === undefined ) return false;
  
  var deska_konf_skryt = $( 'input.material_change:checked' ).attr( "deska-konf-skryt" ).split( "," );
  
  if( jQuery.inArray( vyber_id, deska_konf_skryt ) !== -1 ) return true;
  
  return false;
}

//pro prvotní načtení poslat jako poradi 0
function nactiDalsiKrokKonf( poradi, odlozene )
{
  var def = "";
  var krok = "0";
  var dalsi_poradi = poradi+1;
  $( ".mini_konf_select" ).each(function ()
  {  
    if( vynechatVyber( $(this).attr("data-vyber") ) ) return true;
    
    if( $( this ).attr(  "data-typ" ) === "2" ) 
    {
      var povolit = function( $select )//povolení checkboxů se provede hned, nebo (pokud je předán seznam odložených) až spolu s odpovědí typ=12, ať příslušenství při změně neblikne povolené a hned zase zašedlé
      {
        $select.find( "input[type=checkbox]" ).attr( "disabled", false ).parent().removeClass( "hidden_sedy" );
      };
      if( odlozene ) { var $cil_chk = $( this ); odlozene.push( function() { povolit( $cil_chk ); } ); }
      else povolit( $( this ) );
      return true;
    }
    if( krok !== $( this ).attr( "data-krok" ) )
    {
      def = "";
      krok = $( this ).attr( "data-krok" );
    }
    var prefix = $( this ).attr( "data-krok-prefix" );
    if( prefix !== false && typeof prefix !== 'undefined' )
    {
      def += prefix;
    } 
    if( dalsi_poradi === parseInt( $( this ).attr( "data-poradi" ) ) ) 
    {  
      var zakaz = function( $select )//zákaz se provede hned, nebo (pokud je předán seznam odložených) až spolu s odpovědí typ=12
      {
        $select.find( "option" ).attr( "disabled", true ).hide();
        $select.find( "input[type=radio]" ).not( "input[value=bez_desky]" ).attr( "disabled", true );/*.parent().hide();*/
        $( "#zmenit_vyber_dekor" ).find( "input[type=radio]" ).attr( "disabled", true ).parent().addClass( "hidden_sedy" );//musím zde mít navíc, jelikož je výběr v dialogu a UI dialog přesune kod jinam
      };
      if( odlozene ) { var $cil = $( this ); odlozene.push( function() { zakaz( $cil ); } ); }
      else zakaz( $( this ) );
      return false;
    }
    
    if( $( this ).attr(  "data-typ" ) === "1" ) def += "_" + $( "#konf_blok_" + $(this).attr("data-vyber") + " #" + $( this ).attr( "id" ) + " input[type='radio']:checked" ).val();
    else if( $( this ).attr(  "data-typ" ) === "2" || $( this ).attr(  "data-typ" ) === "3" ) def += "" + $( this ).val();
    else def += "_" + $( this ).val(); 
  }); 
  return def;
}
//skryt posilat jen při prvnotním načtení - aby se skryly barvy noh, které nejsou potřeba
function nactiKonfDostupnost( kod_produktu, vsechny_kody, can_objednat, kategorie, kat_desky, vl, skryt=false )//vl
{ 
  if( kod_produktu === "" || kod_produktu === null ) return;
   
  $.ajax({
    url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
    type: "GET",
    dataType: "html",
    async: false,
    cache: false,

    data: { kod_produktu: kod_produktu, typ: 1, vsechny_kody: vsechny_kody.replaceAll( ":", "|" ), can_objednat: can_objednat, kategorie: kategorie, kat_desky: kat_desky, vl: vl },
    success: function (aData) 
    { 
      if (aData)
      { 
        var result = JSON.parse(aData);
        $.each( result.activate, function (key, value) {
          if( !$( "#konf_prvek_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )//dekor zakázaný materiálem (bez obliny) nechat neaktivní
            $( "#konf_prvek_" + value ).attr( "disabled", false ).parent();//.show();
          if( !$( "#konf_prvek_zmen_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )
            $( "#konf_prvek_zmen_" + value ).attr( "disabled", false ).parent().removeClass( "hidden_sedy" );
        });
        $.each( result.naobjednani, function (key, value) {
          if( !$( "#konf_prvek_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )//dekor zakázaný materiálem (bez obliny) nechat neaktivní
            $( "#konf_prvek_" + value ).attr( "disabled", false ).parent();//.show();
          if( !$( "#konf_prvek_zmen_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )
            $( "#konf_prvek_zmen_" + value ).attr( "disabled", false ).parent().removeClass( "hidden_sedy" );
        });
        
          $.each( result.skryt, function (key, value) {
            if( skryt === true )
            { 
              $( "#konf_prvek_" + value ).parent().remove();
              $( "#konf_prvek_zmen_" + value ).parent().remove();
            }
            else if( $( "#konf_vyber_1000 #konf_prvek_" + value ).length > 0 )
            {
              $( "#konf_prvek_" + value ).attr( "disabled", true ).prop('checked', false).parent().addClass( "hidden_sedy" );
            }
          });
      }
    }
  });
}

//krátkodobá paměť odpovědí jen pro typ=12 a typ=13 (data se mění málo). typ=11 se záměrně neukládá, cena a dostupnost se mění často.
var odpovediPamet = {};
var ODPOVEDI_TTL_MS = 600000;//10 minut pro typ=12 a typ=13
var ODPOVEDI_TTL_TYP11_MS = 60000;//1 minuta pro cenu, dostupnost a obrázek (typ=11), tam se data mění často

function odpovedZPameti( klic, ttl )
{
  var zaznam = odpovediPamet[klic];
  if( zaznam && ( Date.now() - zaznam.cas ) < ( ttl || ODPOVEDI_TTL_MS ) ) return zaznam.data;
  delete odpovediPamet[klic];
  return null;
}

function odpovedDoPameti( klic, data )
{
  odpovediPamet[klic] = { cas: Date.now(), data: data };
}

//běh handleru změny: požadavky jsou asynchronní, loading na tlačítku Přidat do košíku (třída loading na .koupit_stul) se zobrazí až když běh trvá déle než práh
var LOADING_PRAH_MS = 600;//po jak dlouhé době od začátku běhu se loading na tlačítku zobrazí
var aktualniBeh = 0;//číslo posledního běhu handleru, odpovědi starších běhů se zahazují
var behBezi = false;
var pocetOpakovani = 0;//kolikrát po sobě se běh opakoval kvůli odškrtnuté volbě (pojistka proti zacyklení)
var loadingTimer = null;

function behStart()
{
  behBezi = true;
  clearTimeout( loadingTimer );
  loadingTimer = setTimeout( function() { $( ".koupit_stul" ).addClass( "loading" ); }, LOADING_PRAH_MS );
}

function behStop()
{
  behBezi = false;
  pocetOpakovani = 0;
  clearTimeout( loadingTimer );
  $( ".koupit_stul" ).removeClass( "loading" );
  $( document ).trigger( "konfiguratorHotovo" );
}

//během běhu (dokud nedorazí odpovědi) nejde měnit konfiguraci ani koupit se starou konfigurací; prvky se ale nezašeďují, změna vzhledu proběhne až na konci
function blokujBehem( e, selektor )
{
  if( behBezi && e.target.closest && e.target.closest( selektor ) ) { e.preventDefault(); e.stopPropagation(); }
}

document.addEventListener( "click", function( e ) { blokujBehem( e, ".koupit_stul, #mini_konfigurator" ); }, true );
document.addEventListener( "mousedown", function( e ) { blokujBehem( e, "#mini_konfigurator select" ); }, true );//rozbalovací seznam se během běhu neotevře
document.addEventListener( "keydown", function( e ) {//Tab a ostatní klávesy zůstávají, blokuje se jen výběr voleb
  if( [ " ", "Enter", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight" ].indexOf( e.key ) !== -1 ) blokujBehem( e, "#mini_konfigurator input, #mini_konfigurator select" );
}, true );

//kód, který potřebuje hotové dostupnosti (dřív šlo o synchronní chování), počká na dokončení běžícího běhu
function poDokonceni( fn )
{
  if( behBezi ) $( document ).one( "konfiguratorHotovo", fn ); else fn();
}

/**
 * Vrátí zaškrtnuté volitelné příslušenství konfigurátoru (včetně obliny) jako pole kódů,
 * u příslušenství se selectem ve tvaru "kod~hodnota".
 *
 * @returns {string[]}
 */
function vybranePrislusenstvi()
{
  var prsl = [];
  $( "#konf_vyber_1000 .mini_konf_select" ).each( function()
  {
    var $chk = $( this ).find( "input[type=checkbox]:checked:not(:disabled)" );
    if( $chk.length === 0 ) return true;
    var $select = $( this ).find( "select" );
    prsl.push( $chk.val() + ( $select.length > 0 && $select.val() ? "~" + $select.val() : "" ) );
  });
  return prsl;
}

/**
 * Zapíše aktuální konfiguraci do GET parametru konf bez přenačtení stránky (history.replaceState), aby šel odkaz sdílet.
 * Hodnota je base64url z "kroky|prsl|atyp" - kroky podnože a desky ve formátu poznámky produktu (k1_…:k2_…),
 * prsl = volitelné příslušenství oddělené čárkou, atyp = vlastní rozměr desky (např. 120x70). Zakódováno, aby v URL
 * cizích mutací nebyly vidět české kódy.
 *
 * @param {string} kroky
 * @param {string[]} prsl
 * @param {string} atyp
 * @returns {void}
 */
function ulozKonfDoUrl( kroky, prsl, atyp )
{
  if( !window.history || !window.history.replaceState || kroky === "" ) return;

  var hodnota = kroky + "|" + prsl.join( "," ) + "|" + ( atyp || "" );
  var token = btoa( hodnota ).replace( /\+/g, "-" ).replace( /\//g, "_" ).replace( /=+$/, "" );//base64url, kódy konfigurátoru jsou jen ASCII

  var url = new URL( window.location.href );
  url.searchParams.set( "konf", token );
  window.history.replaceState( window.history.state, "", url.pathname + "?" + url.searchParams.toString() + url.hash );
}

//úvodní dotaz se skryt=true (odstranění nepotřebných voleb) se neposílá jako samostatný typ=1, ale jako první krok sloučeného typ=12
var skrytKrok = null;

function pripravSkrytKrok( kod_produktu, vsechny_kody, can_objednat, kategorie )
{
  skrytKrok = { kod_produktu: kod_produktu, vsechny_kody: vsechny_kody, can_objednat: can_objednat, kat_desky: "", vl: "", kategorie: kategorie };
}

//jistota: pokud handler změny krok nespotřeboval (třeba předčasný return), provede se původní samostatný dotaz, stejně jako v originále
function dokonciSkrytKrok()
{
  if( skrytKrok === null ) return;

  var krok = skrytKrok;
  skrytKrok = null;
  nactiKonfDostupnost( krok.kod_produktu, krok.vsechny_kody, krok.can_objednat, krok.kategorie, krok.kat_desky, krok.vl, true );
}

//stejná logika jako nactiKonfDostupnost(), jen pro víc kroků najednou jedním požadavkem (typ=12 místo N × typ=1). Volá se jen ze smyčky, náhrada za skryt=true volání na začátku zůstává beze změny.
function provedOdlozeneZakazy( odlozene )
{
  $.each( odlozene || [], function( key, fn ) { fn(); } );
}

function nactiKonfDostupnostBatch( kroky, kategorie, beh, odlozene )
{
  var skryt_krok = skrytKrok;
  skrytKrok = null;
  if( skryt_krok !== null ) kroky = [ skryt_krok ].concat( kroky );

  var kroky_pripravene = [];
  var odstranit = [];//které kroky mají prvky ze skryt odstranit z DOM (úvodní krok), ostatní je jen zašednou
  $.each( kroky, function( key, krok ) {
    if( krok.kod_produktu === "" || krok.kod_produktu === null || typeof krok.kod_produktu === 'undefined' ) return true;
    odstranit.push( krok === skryt_krok );
    kroky_pripravene.push({
      kod_produktu: krok.kod_produktu,
      vsechny_kody: krok.vsechny_kody.replaceAll( ":", "|" ),
      can_objednat: krok.can_objednat,
      kat_desky: krok.kat_desky,
      vl: krok.vl
    });
  });

  if( kroky_pripravene.length === 0 ) { provedOdlozeneZakazy( odlozene ); return Promise.resolve(); }

  var klic = "12|" + kategorie + "|" + JSON.stringify( kroky_pripravene );
  var z_pameti = odpovedZPameti( klic );
  if( z_pameti !== null )
  {
    provedOdlozeneZakazy( odlozene );
    return Promise.resolve( zpracujDostupnostBatch( z_pameti, odstranit ) );
  }

  var odskrtnuto = false;//některý zaškrtnutý checkbox byl odškrtnut odpovědí
  return new Promise( function( hotovo ) {
    $.ajax({
      url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
      type: "GET",
      dataType: "html",
      async: true,
      cache: false,

      data: { typ: 12, kategorie: kategorie, kroky: JSON.stringify( kroky_pripravene ) },
      success: function (aData)
      {
        if( beh !== aktualniBeh ) return;
        if (aData)
        {
          provedOdlozeneZakazy( odlozene );
          odskrtnuto = zpracujDostupnostBatch( aData, odstranit );
          odpovedDoPameti( klic, aData );
        }
      },
      complete: function() { hotovo( odskrtnuto ); }
    });
  });
}

function zpracujDostupnostBatch( aData, odstranit )
{
  var vysledky = JSON.parse(aData);
  var odskrtnuto = false;//některý zaškrtnutý checkbox byl odškrtnut → další kroky byly spočítané se starým stavem
  $.each( vysledky, function (index, result) {
    $.each( result.activate, function (key, value) {
      if( !$( "#konf_prvek_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )
        $( "#konf_prvek_" + value ).attr( "disabled", false ).parent();
      if( !$( "#konf_prvek_zmen_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )
        $( "#konf_prvek_zmen_" + value ).attr( "disabled", false ).parent().removeClass( "hidden_sedy" );
    });
    $.each( result.naobjednani, function (key, value) {
      if( !$( "#konf_prvek_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )
        $( "#konf_prvek_" + value ).attr( "disabled", false ).parent();
      if( !$( "#konf_prvek_zmen_" + value ).parent().hasClass( "zakaz_dekor_disabled" ) )
        $( "#konf_prvek_zmen_" + value ).attr( "disabled", false ).parent().removeClass( "hidden_sedy" );
    });
    $.each( result.skryt, function (key, value) {
      if( odstranit && odstranit[index] === true )
      {
        $( "#konf_prvek_" + value ).parent().remove();
        $( "#konf_prvek_zmen_" + value ).parent().remove();
      }
      else if( $( "#konf_vyber_1000 #konf_prvek_" + value ).length > 0 )
      {
        if( $( "#konf_prvek_" + value ).prop( "checked" ) ) odskrtnuto = true;
        $( "#konf_prvek_" + value ).attr( "disabled", true ).prop('checked', false).parent().addClass( "hidden_sedy" );
      }
    });
    return !odskrtnuto;//zbylé kroky mají v def už neplatný výběr, počítají se znovu
  });
  return odskrtnuto;
}

//odešle GET požadavek hned a vrátí Promise s { text, z_pameti } nebo s null (chyba sítě, prázdná odpověď). Nic nezpracovává, to řeší volající ve správném pořadí.
function odesliPozadavek( klic, ttl, data )
{
  var z_pameti = odpovedZPameti( klic, ttl );
  if( z_pameti !== null ) return Promise.resolve( { text: z_pameti, z_pameti: true } );

  return new Promise( function( hotovo ) {
    $.ajax({
      url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
      type: "GET",
      dataType: "html",
      async: true,
      cache: false,

      data: data,
      success: function( aData ) { hotovo( aData ? { text: aData, z_pameti: false } : null ); },
      error: function() { hotovo( null ); }
    });
  });
}

//doplňkový obsah k podnoži (popis, fotogalerie, příslušenství) podle master produktu (kod LIKE 'mas_%', kod_vyrobce = kód podnože); volá se jen na pozadí po skončení běhu,
//výsledek se v prohlížeči drží stejně dlouho jako typ=12/13. Když se nic nenajde nebo dotaz selže, nechá se beze změny to, co je na stránce nastavené (žádný fallback na "originál").
function nactiPodnozMaster( kod_podnoze )
{
  var klic = "14|" + kod_podnoze;
  odesliPozadavek( klic, ODPOVEDI_TTL_MS, { typ: 14, kod_podnoze: kod_podnoze } ).then( function( odpoved )
  {
    if( odpoved === null ) return;
    var data;
    try { data = JSON.parse( odpoved.text ); } catch( e ) { return; }
    if( !data ) return;

    if( !odpoved.z_pameti ) odpovedDoPameti( klic, odpoved.text );//uložit i "nenalezeno", ať se pro podnože bez master produktu neposílá požadavek pořád dokola
    if( !data.nalezeno ) return;
    zpracujPodnozMaster( data );
  } );
}

/**
 * Dotáhne doplňkový obsah k aktuálně vybrané podnoži (typ=14) - kód podnože složí z prefixu kroku a zaškrtnuté barvy (#konf_vyber_1).
 *
 * @returns {void}
 */
function nactiPodnozMasterAktualni()
{
  var $podnoz = $( "#konf_vyber_1" );
  var barva_podnoze = $podnoz.find( "input[type=radio]:checked" ).val();
  var krok_prefix_podnoze = $podnoz.attr( "data-krok-prefix" );
  if( barva_podnoze && krok_prefix_podnoze ) nactiPodnozMaster( krok_prefix_podnoze + "_" + barva_podnoze );
}

//vymění příslušenství podle dat z overPodnozMaster() (jen když na stránce existuje odpovídající prvek a server pro ni něco vrátil); popis a fotogalerie jsou níže zakomentované
function zpracujPodnozMaster( data )
{
  //popis a fotogalerie zatím vypnuté, admini na ně nemají připravené zdroje (popisy/fotky podle barvy podnože). Až budou, stačí odkomentovat.
  //Než se popis zapne, je ještě potřeba dořešit spuštění JS věcí na něm (swiper karet, GSAP animace, přehrávání videa na hover u .video-card) - viz historie konverzace:
  //pro swiper a GSAP by mělo stačit document.dispatchEvent( new Event( "swiper-ready" ) ); a document.dispatchEvent( new Event( "scrolltrigger-ready" ) ); (obě navázané trvale),
  //hover video u .video-card jde jen duplikací příslušné části skriptu z e_produkt_popis.tpl do této třídy, nebo jeho předěláním na volatelnou funkci.
  /*
  if( data.popis )
  {
    var $bloky = $( "#popis .produkt_popis_bloky" ).first();
    if( $bloky.length > 0 )
    {
      $bloky.html( data.popis );
      //jquery_start.js přihlašuje videa k lazy-loadingu (source[data-src] -> src) jen jednou při načtení stránky - nově vložená je potřeba přihlásit ručně, jinak se nespustí
      if( window.globalVideoObserver ) $bloky.find( "video" ).each( function() { window.globalVideoObserver.observe( this ); } );
    }
  }

  if( data.fotogalerie && data.fotogalerie.length > 0 ) zpracujPodnozFotogalerii( data.fotogalerie );
  */

  if( data.prislusenstvi_html )
  {
    var $prisl = $( "#prislusenstvi #eshop_produkty" );
    if( $prisl.length > 0 ) $prisl.html( data.prislusenstvi_html );
    var $pocet = $( '.info_uproduktu[data-show="produkt_prislusko_tab"] span' );
    if( $pocet.length > 0 ) $pocet.text( data.prislusenstvi_pocet );
  }
}

//kompletně přestaví hlavní slider (#produkt_obrazek_slider) a fotogalerii (.fotogalerie.fotogalerie_produkt), ať přesně odpovídají počtu fotek/videí z master produktu
//(nejen prvních N). Položky s typ==="video" jsou vždy z YouTube (jediný podporovaný typ videa - viz overPodnozMaster na serveru), takže stačí jako href přímo embed odkaz.
function zpracujPodnozFotogalerii( fotky )
{
  var $slider = $( "#produkt_obrazek_slider" );
  if( $slider.length > 0 )
  {
    $slider.children( '[data-slide]:not([data-slide="0"])' ).remove();//slot 0 nastavuje konfigurátor (typ=11), na ten nesahat
    $.each( fotky, function( i, f ) {
      var slide = i + 1;
      $slider.append(
        '<div class="slider_u_produktu" data-slide="' + slide + '" style="display: none">' +
          '<div class="slider_u_produktu_dorovnani"><img width="500" height="500" src="' + f.plna + '" alt="' + escHtml( f.popis ) + '" loading="lazy" /></div>' +
        '</div>'
      );
    } );
  }

  var $galerie = $( ".fotogalerie.fotogalerie_produkt" ).first();
  if( $galerie.length > 0 )
  {
    var MAX_VIDITELNYCH = 8;//stejný limit jako v šabloně e_produkt_konf.tpl, slot 0 (hlavní fotka z konfigurátoru) se do něj počítá
    $galerie.children( ".fotka_obr" ).not( ".fotka_0" ).remove();//smaže i případnou starou dlaždici "+N" z předchozího volání
    $.each( fotky, function( i, f ) {
      var slide = i + 1;
      if( slide >= MAX_VIDITELNYCH )
      {
        if( slide === MAX_VIDITELNYCH ) $galerie.append( '<div class="fotka_obr open_galery" data-slide="' + MAX_VIDITELNYCH + '"><div><p>+ ' + ( fotky.length - ( MAX_VIDITELNYCH - 1 ) ) + '</p></div></div>' );
        return;
      }
      var href = f.typ === "video" ? f.youtube_url : f.plna;
      $galerie.append(
        '<div class="fotka_obr fotka_' + slide + ( f.typ === "video" ? " video" : "" ) + '" data-slide="' + slide + '">' +
          '<a href="' + href + '" data-sub-html="' + escHtml( f.popis ) + '"><img src="' + f.nahled + '" alt="' + escHtml( f.popis ) + '" loading="lazy" /></a>' +
        '</div>'
      );
    } );

    //stará navázání kliknutí (viz e_produkt.js - vazba mezi hlavním obrázkem a miniaturou) platila jen pro původní prvky; slot 0 má funkční navázání už z načtení stránky, přebindovat jen nové
    $( "#produkt_obrazek_slider .slider_u_produktu:not([data-slide='0']) img" ).off( "click.podnozMaster" ).on( "click.podnozMaster", function () {
      $( ".left-column-img .fotka_" + $( this ).parent().parent().attr( "data-slide" ) + " a" )[0].click();
    } );
    $( ".open_galery" ).off( "click.podnozMaster" ).on( "click.podnozMaster", function () {
      $( ".fotka_" + $( this ).attr( "data-slide" ) + " a" )[0].click();
    } );
  }

  if( typeof refreshGalerie === "function" ) refreshGalerie( "produkt" );//lightGallery si sám znovu přečte aktuální počet položek v .fotogalerie_produkt
}

//jednoduchý escape pro atributy (alt, data-sub-html) sestavované z textu z DB
function escHtml( text )
{
  return $( "<div>" ).text( text || "" ).html().replace( /"/g, "&quot;" );
}

//stejná logika jako nactiKonfPredpocet(), jen pro všechny výběry najednou jedním požadavkem (typ=13 místo N × typ=7); odeslání a zpracování odpovědi jsou odděleně, aby šlo požadavek odeslat souběžně s typ=12
function odesliKonfPredpocetBatch( kod_produktu, polozky )
{
  if( kod_produktu === "" || kod_produktu === null || polozky.length === 0 ) return null;

  var kategorie = polozky[0].kategorie;
  var kroky = [];
  $.each( polozky, function( key, polozka ) {
    kroky.push({ aktual: polozka.aktualni_kod, krok: polozka.krok, vyber: polozka.vyber });
  });

  var klic = "13|" + kod_produktu + "|" + kategorie + "|" + JSON.stringify( kroky );

  return { klic: klic, polozky: polozky, odpoved: odesliPozadavek( klic, ODPOVEDI_TTL_MS, { typ: 13, kod_produktu: kod_produktu, kategorie: kategorie, kroky: JSON.stringify( kroky ) } ) };
}

async function zpracujKonfPredpocetPozadavek( pozadavek, beh )
{
  if( pozadavek === null ) return false;
  var odpoved = await pozadavek.odpoved;
  if( beh !== aktualniBeh || odpoved === null ) return false;//zastaralý běh nebo chyba sítě
  zpracujPredpocetBatch( odpoved.text, pozadavek.polozky );
  if( !odpoved.z_pameti ) odpovedDoPameti( pozadavek.klic, odpoved.text );
  return true;
}

function zpracujPredpocetBatch( aData, polozky )
{
  var vysledky = JSON.parse(aData);
  $.each( polozky, function( index, polozka ) {
    $( ".mini_konf_select[data-vyber='" + polozka.vyber + "'] .extra_pole_cena" ).html( "" );
    var result = vysledky[index];
    if ( result )
    {
      $.each( result, function ( key, value ) {
        $( "label[for='konf_prvek_" + key + "'] .extra_pole_cena" ).html( value );
      });
    }
  });
}

function nactiKonfPredpocet( kod_produktu, item )
{
  if( kod_produktu === "" || kod_produktu === null ) return;
  $.ajax({
    url: '/rsadmin/_funkce/eshop_dostupnost_produkty.php',
    type: "GET",
    dataType: "html",
    async: false,
    cache: false,

    data: { kod_produktu: kod_produktu, typ: 7, aktual: item.aktualni_kod, kategorie: item.kategorie, kat_desky: item.kat_desky, krok: item.krok, vyber: item.vyber },
    success: function (aData) 
    { 
      $( ".mini_konf_select[data-vyber='" + item.vyber + "'] .extra_pole_cena" ).html( "" );
      var result = JSON.parse(aData);
      if ( result )
      {   
        $.each( result, function (key, value) {  
          $( "label[for='konf_prvek_" + key + "'] .extra_pole_cena" ).html( value ); 
        });
      }
    }
  });
}

function odesliCenuDostupnostImg( vsechny_kody, kategorie, vl )
{
  var tri_d = $( "#tri_d" ).val();
  var klic = "11|" + vsechny_kody + "|" + kategorie + "|" + vl + "|" + tri_d;

  return { klic: klic, odpoved: odesliPozadavek( klic, ODPOVEDI_TTL_TYP11_MS, { kod_produktu: vsechny_kody, typ: 11, kategorie: kategorie, vl: vl, tri_d: tri_d } ) };
}

async function zpracujCenuDostupnostImgPozadavek( pozadavek, slider_bx, prvni_pruchod, beh )
{
  var odpoved = await pozadavek.odpoved;
  if( beh !== aktualniBeh || odpoved === null ) return;//zastaralý běh nebo chyba sítě
  zpracujCenuDostupnostImg( odpoved.text, slider_bx, prvni_pruchod );
  if( !odpoved.z_pameti ) odpovedDoPameti( pozadavek.klic, odpoved.text );
}

function zpracujCenuDostupnostImg( aData, slider_bx, prvni_pruchod )
{
  var sklad_class = '';
  var cena = '';
  var result = JSON.parse(aData);
  var cena_nej30 = '';
  
  //$( ".eshop_udaje_usetrite" ).html( "" ).hide();
  if( prvni_pruchod === 0 && $( ".cena_nej30" ).length > 0 ) cena_nej30 = '<div class="cena_nej30">' + $( ".cena_nej30" ).html() + '</div>';
//        if( result.cena_bez_akce !== "" && $( "#js_web_lang_zkr" ).val() !== "cz" ){ cena = "<del>" + result.cena_bez_akce + "</del>"; /*$( ".eshop_udaje_usetrite" ).html( result.usetrite ).show();*/ }
//        else if( result.cena_bez_akce !== "" && $( "#js_web_lang_zkr" ).val() === "cz" ) { cena = "<del class='hidden'>" + result.cena_bez_akce + "</del>"; }
  var s_dph = "<i>" + $( "#cena" ).attr( "data-s" ) + "</i>";
  $( "#cena" ).html( "<span>" + result.cena + s_dph + "</span>" + cena + "<i>" + result.cena_bez_dph + "</i>" + cena_nej30 );
  //$( "#cena_viewport" ).html( "<span>" + result.cena + "</span>" );
  $( "#z_cena" ).val( result.z_cena );
  
  if (result.sklad > 0)
    sklad_class = 'dost0';
  else if( result.dodani_mnozstvi > 0 )
    sklad_class = 'dost20';
  else
    sklad_class = 'dost99';
  $( ".price .dostupnost, .dostupnost_central" ).removeClass( "dost0" ).removeClass( "dost7" ).removeClass( "dost20" ).removeClass( "dost30" ).removeClass( "dost99" );
  $( ".price .dostupnost, .dostupnost_central" ).addClass( sklad_class ).html( result.text );
  
//        $( ".slider_u_produktu" ).attr( "src", result.obrazek ).css( "z-index", "0" ).css( "display", "none" ).attr( "aria-hidden", "true" );
//        $( ".slider_u_produktu:first img" ).attr( "src", result.obrazek ).css( "max-width", "90%" ).css( "max-height", "90%" );
//        $( ".slider_u_produktu:first" ).css( "z-index", "50" ).css( "display", "table" ).attr( "aria-hidden", "false" );
  $( ".slider_u_produktu:first img" ).attr( "src", result.obrazek );
  $( ".fotogalerie .fotka_0 img" ).attr( "src", result.obrazek );
  $( ".fotogalerie .fotka_0 a" ).attr( "href", result.obrazek );
  $( ".slider_u_produktu:first img" ).addClass( "generovany_stul" );
  refreshGalerie( "produkt" );
  //slider_bx.reloadSlider();
  if (slider_bx) slider_bx.goToSlide( 0 );
}

function initInfoTool() {
  const $targets = $(".right-column-konf");

  if (window.matchMedia('(min-width: 992px)').matches) {
    // inicializuj jen pokud tooltip ještě není vytvořený
    $targets.each(function () {
      const $el = $(this);
      if (!$el.data('ui-tooltip')) {
        $el.tooltip({
          track: false, // tooltip nesleduje kurzor
          show: {effect: "fadeIn", duration: 200},
          hide: {effect: "fadeOut", duration: 200},
          position: {my: "center bottom-2", at: "center top"},
          tooltipClass: "konf-tooltip",
          content: function() {
              return $(this).attr('title');
          }
        });
      }
    });
  } else {
    // znič jen pokud tooltip existuje
    $targets.each(function () {
      const $el = $(this);
      if ($el.data('ui-tooltip')) {
        $el.tooltip('destroy');
      }
    });
  }
}